module.exports = __webpack_public_path__ + "img/icon-riesgos-1.503f0d6a.png";